module.exports = __webpack_public_path__ + "static/media/sucafina.ba20ae81.jpg";